import { useAuth } from "@clerk/react"
import { useLayoutEffect, useMemo } from "react"
import { getClerkTokenProvider, setClerkTokenProvider } from "../utils/clerk-token-provider"

export function ClerkTokenSetup({ children }: { children: React.ReactNode }) {
  const { getToken, userId, sessionId } = useAuth()
  const provider = useMemo(
    () => ({
      getToken: (options: Parameters<typeof getToken>[0]) => getToken(options),
      userId,
      sessionId,
    }),
    [getToken, userId, sessionId],
  )

  // Install before descendant passive effects start their API queries.
  useLayoutEffect(() => {
    setClerkTokenProvider(provider)
    return () => {
      if (getClerkTokenProvider() === provider) setClerkTokenProvider(null)
    }
  }, [provider])

  return <>{children}</>
}
